"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactInfoModel = void 0;
const ContactInfoModel = {
    type: Object,
    schema: {
        firstName: { type: String },
        lastName: { type: String },
        email: { type: String },
        phone: { type: String },
        position: { type: String },
    },
};
exports.ContactInfoModel = ContactInfoModel;
